<template>
  <div class="status-container">
    <!-- 状态显示栏 -->
    <div class="status-display">状态: {{ status }}</div>
    <div class="button-group">
      <button class="action-button enable-button" @click="updateStatus(1)">启用</button>
      <button class="action-button disable-button" @click="updateStatus(0)">禁用</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

// 定义状态变量
const status = ref('');

// 打开页面时获取设备状态
const getDeviceStatus = async () => {
  try {
    //const response = await fetch('http://localhost:5053/api2/GetDeviceStatus?ProduceId=2');
    const response = await fetch(`${window.location.origin}/api2/GetDeviceStatus?ProduceId=2`);
    const result = await response.json();
    if (result.code === 1) {
      status.value = result.data;
    }
  } catch (error) {
    console.error('获取设备状态失败:', error);
  }
};

// 修改设备状态
const updateStatus = async (enabled) => {
  try {
    //const response = await fetch(`http://localhost:5053/api2/UpdateDeviceStatus?ProduceId=2&Enabled=${enabled}`);
    const response = await fetch(`${window.location.origin}/api2/UpdateDeviceStatus?ProduceId=2&Enabled=${enabled}`);
    const result = await response.json();
    if (result.code === 1) {
      // 修改成功后刷新页面
      location.reload();
    }
  } catch (error) {
    console.error('修改设备状态失败:', error);
  }
};

// 页面挂载时获取设备状态
onMounted(() => {
  getDeviceStatus();
});
</script>

<style scoped>
.status-container {
  max-width: 400px;
  margin: 20px auto;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.status-display {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

.button-group {
  display: flex;
  justify-content: space-around;
}

.action-button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.enable-button {
  background-color: #4CAF50;
  color: white;
}

.enable-button:hover {
  background-color: #45a049;
}

.disable-button {
  background-color: #f44336;
  color: white;
}

.disable-button:hover {
  background-color: #d32f2f;
}
</style>